import { Box } from '@mui/material';
import { CONTAINER_CLASS, LabelField } from 'src/components/Fields/LabelField';
import { useGroupRules, UserGroupRules } from 'src/graphql';
import { SidePanelRowProps } from 'src/graphql/entities/side-panel-personalization';
import { useConversationEntity } from './conversation-entity-context';

export const LabelsRow = (_props: SidePanelRowProps) => {
  const { conversation, canEdit } = useConversationEntity();
  const { groupRules } = useGroupRules();

  const canAccessToPrivateLabels = groupRules[UserGroupRules.AccessToPrivateLabels];

  return (
    <Box className={CONTAINER_CLASS}>
      <LabelField
        entityId={conversation.conversationId}
        entityName="Conversation"
        partnerId={conversation.partnerId}
        labelAssignments={conversation.labelAssignments}
        isEditable={canEdit}
        marginTop={1}
        paddingInline={2}
        canAccessToPrivateLabels={canAccessToPrivateLabels as boolean}
      />
    </Box>
  );
};
